<template>
  <!-- py-10 mt-20 mb-40  -->
  <div
    :style="{ height: height ? height + 'vh' : '50vh' }"
    class="flex-col py-4 center-content pattern"
  >
    <img src="@/assets/svg/emptyState.svg" />
    <p class="text-base font-medium text-center">{{ message }}</p>
    <p class="font-normal text-sm leading-5 text-[#475467]">{{ subMessage }}</p>
  </div>
</template>

<script>
export default {
  name: "TableEmptyState",
  props: {
    height: {
      type: [String, Number],
      required: false,
    },
    message: {
      type: String,
      required: false,
      default: "No data available",
    },
    subMessage: {
      type: String,
      required: false,
    },
  },
};
</script>

<style></style>
